import { useState } from "react";

export const faqs = [
  {
    q: "黑料热点和普通的吃瓜讨论有什么区别？",
    a: "我们不做情绪站队，也不追着单个截图下结论。每一起事件都会整理成按时间排列的节点，并并列各方说法与依据，让你能在完整脉络里判断，而不是在吵架里判断。",
  },
  {
    q: "你们的事件素材从哪里来？",
    a: "主要来自公开报道、当事人或品牌方的公开账号，以及可查证的现场素材。关键节点会标注出处；无法核实的内容会明确写为待确认，不会被当作事实呈现。",
  },
  {
    q: "时间线是怎么梳理出来的？",
    a: "先建立素材池，再对关键事实做至少两个独立信源的交叉比对，然后按发生顺序拆成节点，最后并列各方视角。整个过程遵循我们公开的四步方法。",
  },
  {
    q: "如果复盘里出现了信息错误怎么办？",
    a: "欢迎通过邮件或订阅表单反馈。核实后我们会更新原文时间线，并在页面中保留修改说明，让读者看到结论是如何被修正的。",
  },
  {
    q: "你们会接受商业推广吗？",
    a: "事件复盘本身不做付费排位，也不会因为合作方而改变节点顺序。若页面存在任何商业内容，我们会在显眼位置标注，保持复盘与推广的清晰边界。",
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-10 px-4 py-12 md:px-8 md:py-16 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <span className="text-xs font-semibold uppercase tracking-widest text-primary-600">
            常见问题
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            关于黑料热点，你可能想问
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            还有别的疑问？欢迎在「关于我们」页面找到联系方式，我们会尽量回复每一条反馈。
          </p>
        </div>

        <div className="lg:col-span-8">
          <div className="divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50">
            {faqs.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div key={item.q}>
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => setOpenIndex(isOpen ? -1 : index)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100 md:px-6"
                  >
                    <span className="font-heading text-base font-semibold text-foreground-950">
                      {item.q}
                    </span>
                    <i
                      className={`shrink-0 text-xl text-primary-600 ${
                        isOpen ? "ri-subtract-line" : "ri-add-line"
                      }`}
                    ></i>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 md:px-6">
                      <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}